/* Baron Biotechs: translated strings + language-aware links */
var S = Object.assign({ empty: 'Your cart is empty.', decrease: 'Decrease', increase: 'Increase', remove: 'Remove', addError: 'Could not add to cart',
  unavailable: 'Unavailable', inStock: 'In stock — ships worldwide', outOfStock: 'Currently out of stock', adding: 'Adding…', added: 'Added ✓' }, window.themeStrings || {});
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  if (root === '/') return;
  var fix = function (a) {
    var h = a.getAttribute('href');
    if (!h || h.charAt(0) !== '/' || h.charAt(1) === '/' || h.indexOf(root) === 0 || h + '/' === root) return;
    if (/^\/(cdn|checkout|cart\/|account\/logout)/.test(h)) return;
    a.setAttribute('href', root.replace(/\/$/, '') + h);
  };
  var run = function () { Array.prototype.forEach.call(document.querySelectorAll('a[href^="/"]'), fix); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
/* Baron Biotechs theme JS */
(function () {
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- money ---------- */
  function money(cents) {
    if (window.BBCur && window.BBCur.active()) return window.BBCur.format(cents);
    var fmt = (window.themeSettings && window.themeSettings.moneyFormat) || '${{amount}}';
    var n = (cents / 100);
    function group(v, sep, dec, decimals) {
      var p = v.toFixed(decimals).split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, sep);
      return p.join(decimals ? dec : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      switch (k) {
        case 'amount': return group(n, ',', '.', 2);
        case 'amount_no_decimals': return group(n, ',', '.', 0);
        case 'amount_with_comma_separator': return group(n, '.', ',', 2);
        case 'amount_no_decimals_with_comma_separator': return group(n, '.', ',', 0);
        case 'amount_with_apostrophe_separator': return group(n, "'", '.', 2);
        default: return group(n, ',', '.', 2);
      }
    });
  }

  /* ---------- Cart (Shopify Ajax API) ---------- */
  var Cart = {
    open: function () { document.body.classList.add('cart-open'); },
    close: function () { document.body.classList.remove('cart-open'); },
    render: function (cart) {
      var body = $('#cartItems'), count = $('#cartCount'), sub = $('#cartSubtotal');
      if (count) count.textContent = cart.item_count;
      if (sub) { sub.setAttribute('data-usd', cart.total_price); sub.textContent = money(cart.total_price); }
      if (!body) return;
      if (!cart.items.length) { body.innerHTML = '<p class="empty-cart">' + S.empty + '</p>'; return; }
      body.innerHTML = cart.items.map(function (item, i) {
        var v = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
        return '<div class="li"><img src="' + (item.image || '') + '" alt="">' +
          '<div style="flex:1"><b>' + item.product_title + '</b>' + (v ? '<small>' + v + '</small>' : '') +
          '<div class="lqty"><button type="button" data-line="' + (i + 1) + '" data-q="' + (item.quantity - 1) + '" aria-label="' + S.decrease + '">−</button>' +
          '<span style="min-width:24px;text-align:center;font-size:13px">' + item.quantity + '</span>' +
          '<button type="button" data-line="' + (i + 1) + '" data-q="' + (item.quantity + 1) + '" aria-label="' + S.increase + '">+</button></div>' +
          '<br><a href="#" class="rm" data-line="' + (i + 1) + '" data-q="0">' + S.remove + '</a></div>' +
          '<span data-usd="' + item.final_line_price + '" style="font-family:var(--serif);font-size:19px;color:var(--gold2)">' + money(item.final_line_price) + '</span></div>';
      }).join('');
      $$('[data-line]', body).forEach(function (b) {
        b.addEventListener('click', function (e) {
          e.preventDefault();
          Cart.change(parseInt(b.getAttribute('data-line'), 10), parseInt(b.getAttribute('data-q'), 10));
        });
      });
    },
    refresh: function () { return fetch('/cart.js').then(function (r) { return r.json(); }).then(Cart.render); },
    add: function (id, qty) {
      return fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: qty || 1 }] })
      }).then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message || S.addError); return d; }); })
        .then(function () { return Cart.refresh(); });
    },
    change: function (line, q) {
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: line, quantity: Math.max(0, q) }) })
        .then(function (r) { return r.json(); }).then(Cart.render);
    }
  };
  window.BaronCart = Cart;

  /* ---------- gold dust canvas ---------- */
  function dust(canvas) {
    if (reduce) return;
    var ctx = canvas.getContext('2d'), w, h, parts = [], color = canvas.getAttribute('data-color') || '236,208,138', running = false, raf;
    function size() { w = canvas.width = canvas.offsetWidth; h = canvas.height = canvas.offsetHeight; }
    function make() { return { x: Math.random() * w, y: Math.random() * h, r: Math.random() * 1.8 + .4, s: Math.random() * .35 + .08, a: Math.random() * .7 + .2, t: Math.random() * 6 }; }
    size(); var n = Math.round(Math.min(70, w / 22)); for (var i = 0; i < n; i++) parts.push(make());
    function frame() {
      ctx.clearRect(0, 0, w, h);
      parts.forEach(function (p) {
        p.y -= p.s; p.x += Math.sin(p.t += .01) * .25; if (p.y < -4) { p.y = h + 4; p.x = Math.random() * w; }
        var tw = .5 + .5 * Math.sin(p.t * 3);
        ctx.beginPath(); ctx.fillStyle = 'rgba(' + color + ',' + (p.a * tw).toFixed(3) + ')';
        ctx.shadowBlur = 8; ctx.shadowColor = 'rgba(' + color + ',.8)';
        ctx.arc(p.x, p.y, p.r, 0, 6.283); ctx.fill();
      });
      raf = requestAnimationFrame(frame);
    }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting && !running) { running = true; frame(); }
        else if (!e.isIntersecting && running) { running = false; cancelAnimationFrame(raf); }
      });
    });
    io.observe(canvas); window.addEventListener('resize', size);
  }

  /* ---------- hero slider ---------- */
  function slider(root) {
    var slides = $$('.hs-slide', root), tabs = $$('.hs-tab', root), i = 0, timer, ms = parseInt(root.getAttribute('data-interval') || '7000', 10);
    if (slides.length < 2) { if (slides[0]) slides[0].classList.add('is-active'); return; }
    root.style.setProperty('--slide-ms', ms + 'ms');
    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); s.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
      tabs.forEach(function (t, k) { t.classList.remove('is-active'); if (k === i) { void t.offsetWidth; t.classList.add('is-active'); } });
    }
    function play() { stop(); if (reduce) return; timer = setInterval(function () { go(i + 1); }, ms); }
    function stop() { clearInterval(timer); }
    tabs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); play(); }); });
    var prev = $('[data-prev]', root), next = $('[data-next]', root);
    if (prev) prev.addEventListener('click', function () { go(i - 1); play(); });
    if (next) next.addEventListener('click', function () { go(i + 1); play(); });
    root.addEventListener('mouseenter', stop); root.addEventListener('mouseleave', play);
    var sx = 0;
    root.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; stop(); }, { passive: true });
    root.addEventListener('touchend', function (e) { var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 50) go(i + (dx < 0 ? 1 : -1)); play(); }, { passive: true });
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : play(); });
    go(0); play();
  }

  document.addEventListener('DOMContentLoaded', function () {
    var hd = $('.site-header');
    var onScroll = function () { if (hd) hd.classList.toggle('solid', window.scrollY > 40); };
    document.addEventListener('scroll', onScroll, { passive: true }); onScroll();

    var burger = $('#burger');
    if (burger) burger.addEventListener('click', function () { document.body.classList.toggle('menu-open'); document.body.classList.remove('search-open'); });
    $$('.links a').forEach(function (a) { a.addEventListener('click', function () { document.body.classList.remove('menu-open'); }); });

    var sb = $('#searchBtn'), sc = $('#searchClose');
    if (sb) sb.addEventListener('click', function () {
      document.body.classList.toggle('search-open');
      var inp = $('.search-panel input'); if (inp && document.body.classList.contains('search-open')) setTimeout(function () { inp.focus(); }, 200);
    });
    if (sc) sc.addEventListener('click', function () { document.body.classList.remove('search-open'); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') document.body.classList.remove('cart-open', 'search-open', 'menu-open'); });

    /* reveal on scroll */
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }); }, { threshold: .12, rootMargin: '0px 0px -40px 0px' });
    $$('.fade').forEach(function (el) { io.observe(el); });

    /* count-up */
    var cio = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return; cio.unobserve(e.target);
        var el = e.target, to = parseInt(el.getAttribute('data-count'), 10), t0 = null;
        if (reduce || isNaN(to)) { el.textContent = to; return; }
        (function step(t) { if (!t0) t0 = t; var p = Math.min((t - t0) / 1400, 1); el.textContent = Math.round(to * (1 - Math.pow(1 - p, 3))); if (p < 1) requestAnimationFrame(step); })(performance.now());
      });
    }, { threshold: .5 });
    $$('[data-count]').forEach(function (el) { cio.observe(el); });

    $$('canvas.dust').forEach(dust);
    $$('[data-slider]').forEach(slider);

    /* qty steppers */
    $$('[data-qty-minus]').forEach(function (b) { b.addEventListener('click', function () { var i = $(b.getAttribute('data-qty-minus')); if (i) i.value = Math.max(1, (parseInt(i.value, 10) || 1) - 1); }); });
    $$('[data-qty-plus]').forEach(function (b) { b.addEventListener('click', function () { var i = $(b.getAttribute('data-qty-plus')); if (i) i.value = (parseInt(i.value, 10) || 1) + 1; }); });

    /* gallery */
    $$('.gallery-thumbs button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var main = $('#mainProductImage'); if (main) main.src = btn.getAttribute('data-full');
        $$('.gallery-thumbs button').forEach(function (b) { b.classList.remove('active'); }); btn.classList.add('active');
      });
    });

    /* cart drawer */
    var cb = $('#cartBtn'), cc = $('#cartClose'), ov = $('#ov');
    if (cb) cb.addEventListener('click', function (e) { e.preventDefault(); Cart.open(); Cart.refresh(); });
    if (cc) cc.addEventListener('click', Cart.close);
    if (ov) ov.addEventListener('click', Cart.close);

    /* product form (add to cart / buy now / variants) */
    var form = $('[data-product-form]');
    if (form) {
      var buyNow = false, json = $('#ProductJSON'), product = json ? JSON.parse(json.textContent) : null;
      $$('[data-buy-now]', form).forEach(function (b) { b.addEventListener('click', function () { buyNow = true; }); });
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var q = parseInt($('[name="quantity"]', form).value, 10) || 1, id = $('[name="id"]', form).value, go = buyNow; buyNow = false;
        var btns = $$('button[type="submit"]', form); btns.forEach(function (b) { b.disabled = true; });
        Cart.add(id, q).then(function () { if (go) window.location.href = '/checkout'; else Cart.open(); })
          .catch(function (err) { alert(err.message); })
          .then(function () { btns.forEach(function (b) { b.disabled = false; }); });
      });
      if (product && product.variants.length > 1) {
        var selects = $$('[data-option-select]', form);
        var update = function () {
          var vals = selects.map(function (s) { return s.value; });
          var v = product.variants.filter(function (x) { return vals.every(function (val, k) { return x['option' + (k + 1)] === val; }); })[0];
          var idEl = $('[name="id"]', form), pr = $('#pdPrice'), cp = $('#pdCompare'), st = $('#pdStock');
          if (!v) { $$('button[type="submit"]', form).forEach(function (b) { b.disabled = true; }); if (st) { st.textContent = S.unavailable; st.classList.add('out'); } return; }
          idEl.value = v.id; if (pr) { pr.setAttribute('data-usd', v.price); pr.textContent = money(v.price); }
          if (cp) { if (v.compare_at_price > v.price) { cp.setAttribute('data-usd', v.compare_at_price); cp.textContent = money(v.compare_at_price); } else { cp.removeAttribute('data-usd'); cp.textContent = ''; } }
          $$('button[type="submit"]', form).forEach(function (b) { b.disabled = !v.available; });
          if (st) { st.textContent = v.available ? S.inStock : S.outOfStock; st.classList.toggle('out', !v.available); }
          var sa = $('#stickyAdd'); if (sa) sa.disabled = !v.available;
          history.replaceState(null, '', '?variant=' + v.id);
        };
        selects.forEach(function (s) { s.addEventListener('change', update); });
      }
      var sticky = $('#stickyAtc'), buyRow = $('#buyRow');
      if (sticky && buyRow && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (es) { es.forEach(function (e) { sticky.classList.toggle('show', !e.isIntersecting && e.boundingClientRect.top < 0); }); }).observe(buyRow);
        var sa = $('#stickyAdd'); if (sa) sa.addEventListener('click', function () { buyRow.querySelector('button[type="submit"]:not([data-buy-now])').click(); });
      }
    }

    /* quick add on cards */
    $$('[data-quick-add]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault(); var old = b.textContent; b.disabled = true; b.textContent = S.adding;
        Cart.add(b.getAttribute('data-quick-add'), 1).then(function () { b.textContent = S.added; Cart.open(); })
          .catch(function (err) { b.textContent = old; alert(err.message); })
          .then(function () { setTimeout(function () { b.disabled = false; b.textContent = old; }, 1600); });
      });
    });

    if ($('#cartItems')) Cart.refresh();
  });
})();
